<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:18
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 01:39:17
-->
<template>
  <div class="accountant-business">
    <Footer :page="1"></Footer>
    <!-- <components :is=""></components> -->
    <div class="top">审核</div>
    <div class="bility">
      <div class="bilityLi" @click="onshipowner(1)">
        <div class="img">
          <img src="../../../assets/dispatch/shipowner.png" alt="" srcset="" />
        </div>
        <div class="text">身份认证</div>
        <div class="number" v-show="idnumber > 0">
          {{ idnumber > 99 ? "99+" : idnumber }}
        </div>
      </div>
      <div class="bilityLi" @click="onshipowner(2)">
        <div class="img">
          <img src="../../../assets/dispatch/vessels.png" alt="" srcset="" />
        </div>
        <div class="text">船只审核</div>
        <div class="number" v-show="shipnumber > 0">
          {{ shipnumber > 99 ? "99+" : shipnumber }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Footer from "@/components/Footer";
import { verifylist, verifyshiplist } from "@/utils/network/toExamine";
import shipowner from "./shipowner.vue";
export default {
  name: "dispatchOrder",
  components: {
    Footer,
  },
  props: {},
  data() {
    return {
      idnumber: 0,
      shipnumber: 0,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getmsg();
  },
  methods: {
    onshipowner(e) {
      Toast.fail("权限暂未开放");
      return;
      if (e == 1) {
        this.$router.push("/dispatch/toExamine/identity");
      } else {
        this.$router.push("/dispatch/toExamine/shipowner");
      }
    },
    // 请求未审核数量
    getmsg() {
      verifylist({
        approveState: 1,
      }).then((res) => {
        this.idnumber = res.total;
      });

      verifyshiplist({
        approveState: 1,
      }).then((res) => {
        this.shipnumber = res.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.accountant-business {
  height: 100vh;
  background-color: #fff;
  //   padding-top: 150px;
  padding-bottom: 70px;
  .top {
    width: 100%;
    background-color: #44b1f9;
    height: 80px;
    color: #fff;
    text-align: center;
    line-height: 80px;
  }
  .bility {
    padding: 20px;
    display: flex;
    align-items: center;
    .bilityLi {
      width: 48px;
      height: 68px;
      margin-right: 20px;
      position: relative;
      .img {
        width: 48px;
        height: 48px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        width: 48px;
        height: 20px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        text-align: center;
        color: #333333;
      }
      .number {
        position: absolute;
        padding: 6px;
        right: -5px;
        top: -5px;
        background: red;
        color: #ffffff;
        border-radius: 50%;
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
      }
    }
  }
}
</style>
